import React, { useMemo } from 'react';
import { Popover } from '@noths/polaris-client-ribbons-design-system';

import { AnonymousAccountLinks } from './AnonymousAccountLinks';
import { AuthenticatedAccountLinks } from './AuthenticatedAccountLinks';
import { useSiteChromeStaticContext } from 'client-site-chrome-ui/context/SiteChromeStaticContext/useSiteChromeStaticContext';
import { useUserContext } from 'client-site-chrome-ui/context/UserContext/useUserContext';

const POPOVER_WIDTH = 234;
const X_OFFSET = 117;
const Y_OFFSET = 18;
const POINTER_CUSTOM_VALUE = 58;
const popOverDimensions = { width: POPOVER_WIDTH };

export interface AccountPopoverProps {
  isOpen: boolean;
  onClose: VoidFunction;
  position: {
    x: number;
    y: number;
  };
}

export const AccountPopover = ({ isOpen, onClose, position }: AccountPopoverProps) => {
  const { compact = false } = useSiteChromeStaticContext();
  const { membershipIsActive, userAuthenticated } = useUserContext();
  const popOverPosition = useMemo(
    () => ({
      left: position.x - X_OFFSET,
      top: position.y + Y_OFFSET,
    }),
    [position.x, position.y],
  );

  return (
    <div data-testid="account-popover">
      <Popover
        bodyOpenClassName=""
        contentLabel="Account popover"
        dimensions={popOverDimensions}
        isOpen={isOpen}
        onRequestClose={onClose}
        pointerAlignment="center"
        pointerCustomValue={POINTER_CUSTOM_VALUE}
        position={popOverPosition}
        shouldReturnFocusAfterClose={false}
      >
        {userAuthenticated ? (
          <AuthenticatedAccountLinks includeFavourites={compact} member={!!membershipIsActive} />
        ) : (
          <AnonymousAccountLinks includeFavourites={compact} />
        )}
      </Popover>
    </div>
  );
};
